(function(app) {

    app.provider("marketingTrackerEventResponderApi",
        [
            function() {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getResponderEventActivity = function (contactEmail) {
                            return marketingTrackerApiGateway.get("/EventGroups/GetResponderEventActivity?email=" + contactEmail, {
                                params: {
                                    email: contactEmail
                                }
                            });
                        };

                        service.postEventResponders = function (eventGroupId, file) {
                            return marketingTrackerApiGateway.postFile("/EventGroups/" + eventGroupId + "/Responders/Upload",
                                file);
                        };

                        service.postRMEEventResponders = function (eventGroupId, file) {
                            return marketingTrackerApiGateway.postFile("/EventGroups/" + eventGroupId + "/Responders/Upload/RME",
                                file);
                        };

                        service.get = function (eventGroupId, eventResponderId) {
                            return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/Responders/" + eventResponderId);
                        };

                        service.create = function (eventGroupId, eventResponder) {
                            return marketingTrackerApiGateway.post("/EventGroups/" + eventGroupId + "/Responders",
                                eventResponder);
                        };

                        service.updateAttended = function (eventGroupId, eventResponderId, boolean) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/Responders/" + eventResponderId + "/Attended?value=" + boolean,
                                {
                                    params: {
                                        value: boolean
                                    }
                                });
                        };

                        service.updateBuyingUnitLeader = function (eventGroupId, eventResponderId, buyingUnitLeaderGuid) {
                            return marketingTrackerApiGateway.put(
                                "/EventGroups/" + eventGroupId + "/Responders/" + eventResponderId + "/BuyingUnitLeader?buyingUnitLeaderGuid=" + buyingUnitLeaderGuid,
                                {
                                    params: {
                                        buyingUnitLeaderGuid: buyingUnitLeaderGuid
                                    }
                                });
                        };

                        service.deleteResponderById = function (eventGroupId, eventResponderId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId + "/Responders/" + eventResponderId);
                        };

                        service.deleteAllResponders = function(eventGroupId) {
                            return marketingTrackerApiGateway.delete("/EventGroups/" + eventGroupId + "/Responders");
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); // jshint ignore:line